module.exports = __webpack_public_path__ + "img/144.8.33109b79.png";